<template>
  <div class="subtitle" :class="modeClass">
    <span>{{ titleText }}</span>
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  titleText: {
    default: '',
    type: String
  },
  modeClass: {
    default: '',
    type: String
  },
})
</script>
<style scoped lang="less">
.subtitle {
  position: relative;
  font-weight: 600;
  font-size: 28rem;
  color: #414141;
  line-height: 40rem;
  display: inline-block;
  padding: 0 10rem;
  min-width: 204rem;
  box-sizing: border-box;

  &>span {
    position: relative;
    z-index: 1;
  }

  &::after {
    content: '';
    width: 100%;
    height: 13rem;
    background: rgba(46, 118, 255, 0.30);
    position: absolute;
    left: 0;
    bottom: -1rem;
  }

  &.black-style{
    color: #fff;
    
    &::after {
      background-color: #5D81C8;
    }
  }

  &.pop-style {
    color: #fff;
    
    &::after {
      background-color: rgba(112, 46, 255, 0.83) !important;
    }
  }

  &.pop-style-light {
    color: #414141;

    &::after {
      background-color: rgba(112, 46, 255, 0.20) !important;
    }
  }
}
</style>